import React from 'react'

export default function result() {
  return (
    <div>result</div>
  )
}
